export default __webpack_public_path__ + "static/media/passport.f6a66054.webp";